import { render, staticRenderFns } from "./CompleteUserAccessInfo.vue?vue&type=template&id=dc5be6a4&scoped=true&"
import script from "./CompleteUserAccessInfo.vue?vue&type=script&lang=js&"
export * from "./CompleteUserAccessInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompleteUserAccessInfo.vue?vue&type=style&index=0&id=dc5be6a4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5be6a4",
  null
  
)

export default component.exports